/* NK — page produit : mention de paiement fractionné sous le bouton d'ajout,
   et badges de paiement agrandis. */
(function () {
  var CSS = [
    '.nk-klarna{',
    '  display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;',
    '  margin:10px 0 0;padding:9px 12px;',
    '  background:#fff;border:1px solid #ececec;border-radius:12px;',
    '  font-family:\'Helvetica Neue\',Helvetica,Arial,sans-serif;',
    '  font-size:13px;line-height:1.3;color:#111;text-align:center;',
    '}',
    '.nk-klarna b{font-weight:700;}',
    '.nk-klarna__logo{',
    '  display:inline-flex;align-items:center;justify-content:center;',
    '  background:#ffb3c7;color:#0b051d;border-radius:5px;',
    '  padding:3px 7px;font-size:11px;font-weight:800;letter-spacing:.02em;',
    '}',
    '@media (max-width:749px){ .nk-klarna{font-size:12.5px;padding:8px 10px;} }',
    /* Badges de paiement : plus grands */
    '.badgeContainer{height:auto !important;}',
    '.badgeContainer img{height:34px !important;width:auto !important;max-height:none !important;}',
    '@media (max-width:749px){ .badgeContainer img{height:28px !important;} }'
  ].join('');

  function style(){
    if (document.getElementById('nk-pdp-pay-css')) return;
    var s = document.createElement('style');
    s.id = 'nk-pdp-pay-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function inject(){
    var box = document.querySelector('.product-form__actions');
    if (!box) return;
    if (box.parentNode.querySelector('.nk-klarna')) return;
    var p = document.createElement('p');
    p.className = 'nk-klarna';
    p.innerHTML = '<span class="nk-klarna__logo">Klarna</span>' +
                  '<span>Payez en <b>3 ou 4 fois</b> à <b>0 % d\'intérêts</b></span>';
    box.insertAdjacentElement('afterend', p);
  }

  function boot(){
    style();
    inject();
    /* la fiche produit se recompose au changement de variante */
    var t = null;
    new MutationObserver(function(){
      clearTimeout(t);
      t = setTimeout(inject, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
